import { ISupport } from "../../../pages/Support/interfaces";


class SupportMapper {
    toPersistence(domainSupport: ISupport): any {
        return {
            id: domainSupport.id,
            name: domainSupport.name,
            phone: domainSupport.phone,
            email: domainSupport.email,
            message: domainSupport.message,
            origin: domainSupport.origin,
            status: domainSupport.status,
            observation: domainSupport.observation,
            panel_user_id: domainSupport.panel_user_id,
            created_at: domainSupport.created_at,
        }
    }


    toDomain(persistenceSupport: any): ISupport {
        return {
            id: persistenceSupport.id,
            name: persistenceSupport.name,
            phone: persistenceSupport.phone,
            email: persistenceSupport.email,
            origin: persistenceSupport.origin,
            message: persistenceSupport.message,
            status: persistenceSupport.status,
            observation: persistenceSupport.observation,
            panel_user_id: persistenceSupport.panel_user_id,
            panel_user: persistenceSupport.panel_user ? {
                id: persistenceSupport.panel_user.id,
                name: persistenceSupport.panel_user.name,
            } : null,
            created_at: persistenceSupport.created_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SupportMapper();
